import { useEffect, useState } from 'react';
import { backtestApi } from '@/api/client';
import { SPEED_RUN_EVENT, inSpeedRun, runPicks, runSignal, setRunBacktestFailed, setRunPick } from '@/lib/speedRun';
import { RUN_SIGNAL } from '@/lib/speedRunPath.core';
import { jumpTo, runStepIndex, seenSignals } from '@/lib/speedRunEngine.core';
import { BACKTEST_WATCH_MS, backtestFailed, backtestFinished, shouldWatchBacktest } from '@/lib/backtestDoneWatch.core';
import { SPEED_RUN_PATH } from '@/lib/speedRunPath.core';

/**
 * Mounted once (MainLayout): sends RUN_SIGNAL.backtestDone when the run's
 * backtest finishes, wherever the person is (lib/backtestDoneWatch.core.ts).
 */
export function SpeedRunBacktestWatch() {
  // Re-checked on a run's start/end and every poll (runPicks change with no event).
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const bump = () => setTick((n) => n + 1);
    window.addEventListener(SPEED_RUN_EVENT, bump);
    const id = setInterval(bump, BACKTEST_WATCH_MS);
    return () => { window.removeEventListener(SPEED_RUN_EVENT, bump); clearInterval(id); };
  }, []);

  useEffect(() => {
    const id = runPicks().backtestId;
    if (!shouldWatchBacktest(inSpeedRun(), id, seenSignals(), RUN_SIGNAL.backtestDone)) return;
    let cancelled = false;
    backtestApi.get(Number(id)).then((b) => {
      if (cancelled || !inSpeedRun() || seenSignals().includes(RUN_SIGNAL.backtestDone)) return;
      if (backtestFinished(b?.status)) runSignal(RUN_SIGNAL.backtestDone);
      else if (backtestFailed(b?.status)) {
        // Back to the backtest step, which says it failed; never past it (a step the person already passed stays passed).
        setRunPick({ backtestId: '' });
        setRunBacktestFailed(true);
        const at = SPEED_RUN_PATH.findIndex((s) => s.id === 'backtest');
        if (at >= 0 && runStepIndex() > at) jumpTo('backtest');
        try { window.dispatchEvent(new Event(SPEED_RUN_EVENT)); } catch { /* native */ }
      }
    }).catch(() => { /* next poll */ });
    return () => { cancelled = true; };
  }, [tick]);

  return null;
}
